import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IUpdateScheduleData {
  schedule_id: string;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  from_user_id?: string;
  to_user_id?: string;
  event_pid?: string;
}

const updateScheduleShift = (postData: IUpdateScheduleData) => {
  return http().post(endpoints.scheduling.updateShift, postData);
};

export function useUpdateScheduleShift() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateScheduleShift,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['fetchCalendarView'] });
    },
  });
}
